import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { DashboardSidebar } from '@/layouts/dashboard';
import { Link } from 'react-router-dom';
import { t } from 'i18next';
import { IconWrapper } from '@/components/custom/icon';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { FilterTitle } from '@/components/custom/filter';

export function CourseSidebar(props) {
  const { steps, currentStep, setCurrentStep, edit } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack asChild>
        <Link to="/curso/admin">
          <IconWrapper>
            <FiChevronLeft />
          </IconWrapper>
          <ButtonBackContent>
            <FilterTitle>{t('sideBar.courses')}</FilterTitle>
          </ButtonBackContent>
        </Link>
      </ButtonBack>

      <ul className="step-by-step-nav">
        {steps.map((step, index) => {
          return (
            <li
              className={`step-by-step-nav__item ${index === currentStep ? 'active' : ''} ${currentStep > index ? 'step-by-step-nav__item--completed' : ''}`}
              onClick={() => edit && setCurrentStep(index)}
              key={index}
            >
              <Link
                to={edit ? `/lms/criar/modulo/${step.route}` : ''}
                className="step-by-step-nav__link"
                style={{ cursor: edit ? 'pointer' : 'default' }}
              >
                {step.text}
              </Link>
            </li>
          );
        })}
      </ul>
    </DashboardSidebar>
  );
}
